export default function Marquee() {
  const phrase = "INDIA  ·  UK  ·  MIDDLE EAST  ·  YIWU  ·  GLOBAL  ·  ";
  const content = phrase.repeat(6);
  return (
    <div
      data-testid="marquee-section"
      className="relative overflow-hidden bg-ink-50 border-y border-black/5 py-6 md:py-14"
    >
      <div className="flex whitespace-nowrap animate-marquee-x">
        <div className="flex shrink-0 font-heading font-black uppercase tracking-tighter text-[14vw] md:text-[10vw] leading-[0.9]">
          <span className="pr-10 text-stroke">{content}</span>
          <span className="pr-10 text-stroke">{content}</span>
        </div>
      </div>
    </div>
  );
}
